import { createRouter, createWebHistory, type Router } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const router: Router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/login/:jwt',
            name: 'Login',
            component: () => import('@/views/LoginPage.vue'),
        },
        {
            path: '/logout',
            name: 'Logout',
            component: () => import('@/views/LogoutPage.vue'),
        },
        {
            path: '/',
            name: 'Dashboard',
            component: () => import('@/views/DashboardPage.vue'),
        },
        {
            path: '/charterRoutes',
            name: 'charterRoutes',
            component: () => import('@/views/CharterRoutes.vue'),
        },
        {
            path: '/busRoutes',
            name: 'busRoutes',
            component: () => import('@/views/BusRoutes.vue'),
        },
        {
            path: '/airlineCaches',
            name: 'airlineCaches',
            component: () => import('@/views/AirlineRoutes/AirlineIndex.vue'),
            children: [
                {
                    path: '',
                    name: 'airlineCachesOverview',
                    component: () => import('@/views/AirlineRoutes/AirlineRoutes.vue'),
                },
                {
                    path: 'addAirline',
                    name: 'addNewAirlineRoute',
                    component: () => import('@/views/AirlineRoutes/AddAirline.vue'),
                },
                {
                    path: 'editAirline/:id',
                    name: 'editAirlineRoute',
                    component: () => import('@/views/AirlineRoutes/AddAirline.vue'),
                },
            ],
        },
        {
            path: '/packages',
            name: 'Packages',
            component: () => import('@/views/Packages/PackagesIndex.vue'),
            children: [
                {
                    path: '',
                    name: 'packagesList',
                    component: () => import('@/views/Packages/PackagesList.vue'),
                },
                {
                    path: 'buildPackage/:id?/:isGroup?',
                    name: 'buildNewPackages',
                    component: () => import('@/views/Packages/BuildPackage.vue'),
                },
                {
                    path: 'packageReport/:id?/:isGroup?',
                    name: 'packageReport',
                    component: () => import('@/views/Packages/PackageReport.vue'),
                },
                {
                    path: 'packageLogs/:id?/:isGroup?',
                    name: 'packageLogs',
                    component: () => import('@/views/Packages/PackageLogs.vue'),
                },
                {
                    path: 'banRoomTypes',
                    name: 'banRoomTypes',
                    component: () => import('@/views/Packages/RoomsBlacklist.vue'),
                },
            ],
        },
        {
            path: '/caching',
            name: 'Caching',
            component: () => import('@/views/Cache/CachingIndex.vue'),
            children: [
                {
                    path: '',
                    name: 'Cache',
                    component: () => import('@/views/Cache/CachingPage.vue'),
                },
                {
                    path: 'jobs/:id?',
                    name: 'Jobs',
                    component: () => import('@/views/Cache/Jobs.vue'),
                },
            ],
        },
        {
            path: '/wallet',
            name: 'Wallet',
            component: () => import('@/views/WalletPage.vue'),
        },
        {
            path: '/bookings',
            name: 'Bookings',
            component: () => import('@/views/BookingsPage.vue'),
        },
        {
            path: '/ucm',
            name: 'UCM',
            component: () => import('@/views/UCM/UCMIndex.vue'),
            children: [
                {
                    path: 'hotels',
                    name: 'Unified Hotel Data Integration System',
                    component: () => import('@/views/UCM/HotelsList.vue'),
                },
                {
                    path: 'hotel',
                    name: 'Hotel',
                    component: () => import('@/views/UCM/Hotel.vue'),
                },
            ],
        },
        {
            path: '/extra',
            name: 'Extra',
            component: () => import('@/views/Extra/ExtraIndex.vue'),
            children: [
                {
                    path: 'list',
                    name: 'extrasList',
                    component: () => import('@/views/Extra/ExtraList.vue'),
                },
                {
                    path: ':id?',
                    name: 'extraAdd',
                    component: () => import('@/views/Extra/Extra.vue'),
                },
                {
                    path: '/allocation/list',
                    name: 'allocationsList',
                    component: () => import('@/views/Extra/AllocationList.vue'),
                },
                {
                    path: '/allocation/:id?',
                    name: 'allocationAdd',
                    component: () => import('@/views/Extra/Allocation.vue'),
                },
            ],
        },
        {
            path: '/:pathMatch(.*)*',
            name: '404',
            component: () => import('@/views/PathNotFound.vue'),
        },
    ],
});

router.beforeEach((to, from, next) => {
    const auth = useAuthStore();
    if (to.name === 'Login') {
        next();
    } else if (!auth.isAuthenticated && to.name !== 'Logout') {
        next('/logout');
    } else {
        next();
    }
});

export default router;
